export const products = [
  {
    id: 3,
    title: "Waterless Wash and Wax",
    price: "25.99",
    oldPrice: "29.99",
    category: "Carwash",
    image: "img/shop/CarwashProducts/Waterless Wash and Wax.png",
    brand: "Green kleen",
    description: "Experience a powerful clean and lasting shine with our Waterless Wash and Wax—just spray, wipe, and buff for a showroom finish with UV protection.",
    gallery: {
      thumbs: [
         
        "img/shop/details/CarwashProducts/Waterless Wash and Wax thumb2.png",
        "img/shop/details/CarwashProducts/Waterless Wash and Wax thumb3.png",
      ],
      large: [
         
        "img/shop/details/CarwashProducts/Waterless Wash and Wax Large2.png",
        "img/shop/details/CarwashProducts/Waterless Wash and Wax Large3.png",
      ]
    },
    details: {
      fullDescription: "Our advanced Waterless Wash and Wax formula combines powerful cleaning agents with natural waxes, delivering a sparkling, showroom finish without a drop of water. Perfectly engineered to lift dirt and grime safely while simultaneously protecting your vehicle's paint from UV rays and environmental contaminants. Simply spray, wipe, and buff to achieve exceptional shine and protection.",
      weight: "2.1 lbs",
      dimensions: "10 × 6 × 6 in",
      size: "One size"
    }
  },
  {
    id: 4,
    title: "Tire Shine",
    price: "18.99",
    oldPrice: "22.99",
    category: "Carwash",
    image: "img/shop/CarwashProducts/Tire Shine.png",
    brand: "Green Kleen",
    description: "Restores rich, black finish with a glossy, water-repellent layer that protects against cracking and aging.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Tire Shine thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Trie Shine Large1.png",
      ]
    },
    details: {
      fullDescription: "Green Kleen Tire Shine restores the rich, black finish of your tires, providing a durable, glossy appearance that repels dust and water. Formulated with eco-friendly ingredients, it penetrates deep into tire surfaces, preventing cracking and aging, leaving a professional look with minimal effort.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 5,
    title: "Microfiber Towels",
    price: "15.99",
    oldPrice: "19.99",
    category: "Accessories",
    image: "img/shop/CarwashProducts/Microfiber Towels.png",
    brand: "Green Kleen",
    description: "Ultra-absorbent, streak-free towels designed for safe, scratch-free waterless cleaning.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Microfiber Towels thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Microfiber Towels Large1.png",
      ]
    },
    details: {
      fullDescription: "Our premium-quality Microfiber Towels are ultra-absorbent and gentle on surfaces, ideal for achieving streak-free and lint-free results. Engineered specifically for waterless cleaning, these towels efficiently lift and trap dirt particles, significantly reducing the risk of scratching your vehicle's delicate finishes.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 6,
    title: "Dashboard Polish",
    price: "",
    oldPrice: "",
    category: "Interior Care",
    image: "img/shop/CarwashProducts/Dashboard Polish.png",
    brand: "Green Kleen",
    description: "Non-toxic polish that cleans, conditions, and protects with a matte finish that resists dust and UV rays.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Dashboard Polish thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Dashboard Polish Large1.png",
      ]
    },
    details: {
      fullDescription: "Keep your vehicle's interior looking pristine with Green Kleen Dashboard Polish. This non-toxic, eco-friendly solution cleans, conditions, and protects interior surfaces, leaving a non-greasy, matte finish that repels dust and dirt, while protecting from UV damage.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 7,
    title: "Window Cleaner",
    price: "",
    oldPrice: "",
    category: "Glass Care",
    image: "img/shop/CarwashProducts/Window Cleaner.png",
    brand: "Green Kleen",
    description: "Streak-free, crystal-clear cleaning for windows and mirrors with an advanced, residue-free formula.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Window Cleaner thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Window Cleaner Large1.png",
      ]
    },
    details: {
      fullDescription: "Green Kleen Window Cleaner offers a crystal-clear, streak-free finish with every use. Its advanced formula effortlessly removes fingerprints, smudges, and grime from glass surfaces. Ideal for windows, mirrors, and all transparent surfaces, leaving behind nothing but sparkling clarity.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 8,
    title: "Multipurpose Cleaner",
    price: "",
    oldPrice: "",
    category: "All Purpose",
    image: "img/shop/CarwashProducts/Multipurpose Cleaner.png",
    brand: "Green Kleen",
    description: "Powerful and eco-friendly solution that breaks down grime, oil, and dirt across multiple surfaces.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Multipurpose Cleaner thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Multipurpose Cleaner Large1.png",
      ]
    },
    details: {
      fullDescription: "Our versatile Multipurpose Cleaner tackles a wide range of tough stains and residues from various surfaces. Safe and effective, this eco-friendly formula quickly breaks down dirt, oil, and grime, leaving surfaces clean, fresh, and residue-free. Perfect for vehicles, home, and office use.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 9,
    title: "High Foam Car Wash",
    price: "",
    oldPrice: "",
    category: "Carwash",
    image: "img/shop/CarwashProducts/High Foam Car Wash.png",
    brand: "Green Kleen",
    description: "Thick, biodegradable foam that gently lifts dirt without stripping waxes or sealants.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/High Foam Car Wash thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/High Foam Car Wash Large1.png",
      ]
    },
    details: {
      fullDescription: "Green Kleen High Foam Car Wash delivers luxurious, thick foam that gently lifts dirt, contaminants, and grime from your vehicle's surface. Environmentally friendly and biodegradable, it cleans effectively without stripping away protective waxes or sealants, leaving your vehicle sparkling clean.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 10,
    title: "Upholstery Cleaner",
    price: "",
    oldPrice: "",
    category: "Interior Care",
    image: "img/shop/CarwashProducts/Upholstery Cleaner.png",
    brand: "Green Kleen",
    description: "Stain and odor remover safe for all fabric types, leaving interiors refreshed and spotless.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Upholstery Cleaner thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Upholstery Cleaner Large1.png",
      ]
    },
    details: {
      fullDescription: "Restore your vehicle's upholstery with Green Kleen Upholstery Cleaner. This powerful yet gentle cleaner removes stubborn stains, spills, and odors from fabric and carpets. Safe for all upholstery types, it refreshes interiors without harsh chemicals, leaving a pleasant scent and spotless finish.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  },
  {
    id: 11,
    title: "Leather Cleaner",
    price: "",
    oldPrice: "",
    category: "Interior Care",
    image: "img/shop/CarwashProducts/Leather Cleaner.png",
    brand: "Green Kleen",
    description: "Cleans and nourishes leather surfaces for a soft, supple finish without harsh chemicals.",
    gallery: {
      thumbs: [
        "img/shop/details/CarwashProducts/Leather Cleaner thumb1.png",
      ],
      large: [
        "img/shop/details/CarwashProducts/Leather Cleaner Large1.png",
      ]
    },
    details: {
      fullDescription: "Green Kleen Leather Cleaner revitalizes leather surfaces, restoring their natural beauty and softness. This gentle, eco-friendly formula safely removes dirt, body oils, and grime without drying or damaging the leather. It leaves behind a clean, supple finish while protecting against future wear and tear.",
      weight: "",
      dimensions: "",
      size: "One size"
    }
  }
];



// trolley products data



export const carwashTrolleys = [
  // {
  //   id: 101,
  //   title: "Car wash trolley – Square",
  //   price: "12",
  //   oldPrice: "",
  //   category: "Carwash",
  //   image: "img/shop/CarwashTrolly/Car wash trolley-square.png",
  //   brand: "Green kleen",
  //   description: "The Car Wash Trolley – Square is built with durable fiberglass reinforced plastic and resin. It holds up to 60 liters of water with a drainage capacity of 20 liters. Designed for easy mobility, it features 4 rubberized wheels—2 pieces of 5-inch swivel wheels with brake casters and 2 pieces of 5-inch fixed plate wheels. Electrical wiring includes copper clips for efficient connection, supported by one angle iron and a 6-meter pipe with 2 connectors. The system uses an illuminated push button switch, operates on a 12V and 35Amp battery, and runs a single motor with a working pressure of 4.5–4.8 A. Accessories include a spray gun, connectors, filter, pipe, and more—making it a compact, professional solution for all your car wash needs.",
  //   gallery: {
  //     thumbs: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square thumb1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square thumb2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square thumb3.png"
  //     ],
  //     large: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square Large1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square Large2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Square Large3.png"
  //     ]
  //   },
  //   details: {
  //     fullDescription: "Our Car Wash Trolley – Box Shaped features a sleek design with two separable tanks: a spacious main tank and a dedicated drainage tank, preventing leaks commonly found in glue-partition models. The large top surface offers ample space to hold car wash tools and accessories, making it ideal for professionals. Designed for mobility and compactness, it ensures maximum convenience and water management during operations. Highly versatile and time-efficient, this trolley is a valuable asset for car cleaning businesses and detailing enthusiasts alike",
  //     ProductSize: " 770 x 400 x 880 mm",
  //     PackageSize: " 816 x 436 x 894 mm",
  //     avilableColors: " Yellow & Blue , Green & Black , Red & Black , White & Green, Full Black, Yellow & Black, White & black, Full green, Full Yellow, Orange Black"
  //   }
  // },
  // {
  //   id: 102,
  //   title: "Car wash trolley – Oval",
  //   price: "",
  //   oldPrice: "",
  //   category: "Carwash",
  //   image: "img/shop/CarwashTrolly/Car wash trolley – Oval.png",
  //   brand: "Green kleen",
  //   description: "The Car Wash Trolley – Compact Round by Kreen Kleen is made from durable fiberglass reinforced plastic with resin for long-lasting performance. It features a 60-liter water capacity and runs on a 12V, 35A battery with a working pressure of 4.5–4.8 A. The trolley is equipped with 3 rubberized wheels—1 piece of 5-inch swivel wheel with brake caster and 2 fixed 5-inch wheels—for smooth mobility. It includes electrical wiring with copper clips, one angle iron support, and a 6-meter pipe with 2 connectors. The system operates via an illuminated push button switch and comes with essential accessories like a spray gun, connectors, filter, and pipe—perfect for efficient and mobile car cleaning.",
  //   gallery: {
  //     thumbs: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval thumb1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval thumb2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval thumb3.png"
  //     ],
  //     large: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval Large1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval Large2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Oval Large3.png"
  //     ]
  //   },
  //   details: {
  //     fullDescription: "Our car wash trolley – Oval shaped is small and compact one with affordable price. A car wash trolley, also known as a mobile car wash cart or equipment, is a convenient and efficient tool used in the car detailing and car wash industry. It offers several benefits and features that make it a valuable asset for car cleaning businesses and enthusiasts alike. Here are some of the benefits and features of a car wash trolley.",
  //     ProductSize: " 600 x 410 x 870 mm",
  //     PackageSize: " 616 x 436 x 884 mm",
  //     avilableColors: " Yellow & Blue , Yellow & Black , Green & Black , White & Green , Red & Black , Full black, White & black, Full green."
  //   }
  // },
  // {
  //   id: 103,
  //   title: "Car Wash Trolley – Pear",
  //   price: "",
  //   oldPrice: "",
  //   category: "Carwash",
  //   image: "img/shop/CarwashTrolly/Car wash trolley – Pear.png",
  //   brand: "Green kleen",
  //   description: "The Car Wash Trolley – Round Model by Kreen Kleen is crafted from strong fiberglass reinforced plastic with resin, offering durability and reliability. It features a 60-liter water capacity along with a 30-liter drainage tank for efficient waste management. Designed with 3 rubberized wheels—1 piece of 5-inch swivel wheel with brake caster and 2 fixed 5-inch wheels—it provides excellent mobility and control. The unit is powered by a 12V, 35A battery, operates at 4.5–4.8 A, and is equipped with copper clip wiring, a 6-meter pipe with 2 connectors, and a single motor. An illuminated push button switch ensures ease of use, and the set includes essential accessories like a spray gun, connectors, filter, and pipe—ideal for professional and mobile car washing needs.",
  //   gallery: {
  //     thumbs: [
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear thumb1.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear thumb2.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear thumb3.png"
  //     ],
  //     large: [
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear Large1.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear Large2.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Pear Large3.png"
  //     ]
  //   },
  //   details: {
  //     fullDescription: "Our car wash trolley – Oval shaped is small and compact one with affordable price. A car wash trolley, also known as a mobile car wash cart or equipment, is a convenient and efficient tool used in the car detailing and car wash industry. It offers several benefits and features that make it a valuable asset for car cleaning businesses and enthusiasts alike. Here are some of the benefits and features of a car wash trolley.",
  //     ProductSize: " 600 x 410 x 870 mm",
  //     PackageSize: " 616 x 436 x 884 mm",
  //     avilableColors: " Yellow & Blue , Yellow & Black , Green & Black , White & Green , Red & Black , Full black, White & black, Full green."
  //   }
  // },
  // {
  //   id: 104,
  //   title: "Car wash trolley – Heli",
  //   price: "",
  //   oldPrice: "",
  //   category: "Carwash",
  //   image: "img/shop/CarwashTrolly/Car wash trolley – Heli.png",
  //   brand: "Green kleen",
  //   description: "The Car Wash Trolley – Pear Shaped by Kreen Kleen is designed with a spacious 100-liter water tank and a 20-liter drainage capacity, all built from durable fiberglass reinforced plastic with resin. Its closed-top design ensures safe storage of tools and accessories during operation. Mobility is effortless with 3 rubberized wheels—1 piece of 5-inch swivel with brake caster and 2 pieces of 5-inch caster wheels. It features electrical wiring with copper clips, a 6-meter pipe with 2 connectors, and one angle iron for added support. Powered by a 12V, 35A battery and a single motor, it operates at a working pressure of 4.5–4.8 A. The illuminated push button switch adds ease of control, while the included accessories—gun, connectors, filter, and pipe—make this trolley a complete solution for efficient and professional car washing.",
  //   gallery: {
  //     thumbs: [
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli thumb1.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli thumb2.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli thumb3.png"
  //     ],
  //     large: [
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli Large1.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli Large2.png",
  //       "img/shop/details/Carwashtrolley/Car was trolley – Heli Large3.png"
  //     ]
  //   },
  //   details: {
  //     fullDescription: "Our Helicopter Car Wash Cart is uniquely designed with a spacious main tank, separate drain tank, and dedicated storage space, allowing users to neatly organize and store all their washing tools inside the cart. Also known as a mobile car wash unit, this cart is a highly efficient solution for car detailing professionals and cleaning enthusiasts. Its easily portable build and distinctive water-saving design make it a reliable and eco-friendly choice for modern car wash operations, offering both convenience and performance in one compact package.",
  //     ProductSize: " 800 x 520 x 900 mm",
  //     PackageSize: " 810 x 530 x 910 mm",
  //     avilableColors: " Yellow & Blue , Yellow & Black, Green & Black , Red & Black ,Full black, Full green ,White & Green"
  //   }
  // },
  // {
  //   id: 105,
  //   title: "Car wash trolley – Pearl",
  //   price: "",
  //   oldPrice: "",
  //   category: "Carwash",
  //   image: "img/shop/CarwashTrolly/Car wash trolley – Pearl.png",
  //   brand: "Green kleen",
  //   description: "The Car Wash Trolley – Pearl   features a durable fiberglass reinforced plastic body with a 120L water tank and smooth-mobility rubberized wheels. Powered by a 12V, 35A battery and equipped with essential accessories, it delivers efficient and professional car washing performance.",
  //   gallery: {
  //     thumbs: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl thumb1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl thumb2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl thumb3.png"
  //     ],
  //     large: [
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl Large1.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl Large2.png",
  //       "img/shop/details/Carwashtrolley/Car wash trolley – Pearl Large3.png"
  //     ]
  //   },
  //   details: {
  //     fullDescription: "The Car Wash Trolley – Pearl   features a durable fiberglass reinforced plastic body with a 120L water tank and smooth-mobility rubberized wheels. Powered by a 12V, 35A battery and equipped with essential accessories, it delivers efficient and professional car washing performance.",
  //     ProductSize: " 770 x 400 x 880 mm",
  //     PackageSize: "  816 x 436 x 894 mm",
  //     avilableColors: " Yellow & Blue , Green & Black , Red & Black , White & Green, Full Black, Yellow & Black, White & black, Full green, Full Yellow, Orange Black"
  //   }
  // },
  {
    id: 106,
    title: "Green Kleen Car Wash Trolley",
    price: "",
    oldPrice: "",
    category: "Carwash",
    image: "img/shop/CarwashTrolly/Car wash trolley – larger.jpg",
    brand: "Green kleen",
    description: "The Green Kleen Car Wash Trolley is a highly mobile, self-contained washing solution engineered for professional fleet servicing and commercial cleaning operations. Featuring a heavy-duty fiberglass reinforced plastic body integrated with an exceptional 120L capacity water tank, this premium unit operates seamlessly without dedicated utility lines, providing maximum commercial efficiency on the move.",
    gallery: {
      thumbs: [
        "img/shop/details/Carwashtrolley/carwash-trolly-lager thumb1.jpg",
        "img/shop/details/Carwashtrolley/carwash-trolly-lager thumb2.jpg",
        "img/shop/details/Carwashtrolley/carwash-trolly-lager thumb3.jpg"
      ],
      large: [
        "img/shop/details/Carwashtrolley/carwash-trolly-lager1.jpg",
        "img/shop/details/Carwashtrolley/carwash-trolly-lager2.jpg",
        "img/shop/details/Carwashtrolley/carwash-trolly-lager3.jpg"
      ]
    },
    details: {
      fullDescription: "The Green Kleen Car Wash Trolley is a highly mobile, self-contained washing solution engineered for professional fleet servicing and commercial cleaning operations. It features a premium FRP build, an independent power asset (12V, 35A battery), regulated output (4.5–4.8 A), quiet rubberized wheels, heavy-duty copper clip connections, and a water-resistant power switch. Standard accessory kit includes: industrial-grade spray gun, premium delivery pipe, secure connectors, and inline fluid filter.",
      ProductSize: " 770 x 400 x 880 mm",
      PackageSize: " 816 x 436 x 894 mm",
      avilableColors: " Yellow & Blue, Green & Black, Red & Black, White & Green, Full Black, Yellow & Black, White & Black, Full Green, Full Yellow, Orange & Black",
      tankCapacity: "120 Liters",
      powerSupply: "12V, 35A Battery",
      workingCurrent: "4.5 – 4.8 A",
      bodyMaterial: "Fiberglass (FRP)",
      wheelType: "Rubberized Mobility",
      keyFeatures: [
        { label: "Premium FRP Build", desc: "Durable fiberglass reinforced plastic construction designed to withstand rigorous commercial usage environments." },
        { label: "Independent Power Asset", desc: "High-performance 12V, 35A battery configuration ensures long operational cycles." },
        { label: "Regulated Output", desc: "Optimal working current of 4.5–4.8 A delivers balanced, steady pressure execution." },
        { label: "Fluid Mobility", desc: "Smooth-rolling rubberized wheels offer quiet, effortless navigation across various floor dynamics." },
        { label: "Heavy-Duty Infrastructure", desc: "Features specialized copper clip wiring connections for maximum electrical efficiency and conductivity." },
        { label: "Enhanced Safety", desc: "Built with a visible, water-resistant illuminated push-button power control switch." }
      ],
      accessoryKit: "Fully equipped with an industrial-grade spray gun, premium delivery pipe, heavy-duty secure connectors, and a specialized inline fluid filter."
    }
  }
]; 